(() => {
  const root = document.querySelector(".cm-stock-countdown");
  if (!root) return;

  const elCountdownWrap = root.querySelector('[data-mode="countdown"]');
  const elInfoWrap = root.querySelector('[data-mode="info"]');
  const elTime = root.querySelector(".cm-stock-countdown__time");
  const elWhen = root.querySelector(".cm-stock-countdown__when");

  // Stop helt hvis markup ikke matcher forventning
  if (!elCountdownWrap || !elInfoWrap || !elTime || !elWhen) return;

  const inStock = String(root.dataset.inStock) === "true";
  const cutoffHour = parseInt(root.dataset.cutoffHour || "14", 10);
  const eveningHour = parseInt(root.dataset.eveningHour || "20", 10);
  const after20Wording = (root.dataset.after20Wording || "tomorrow").toLowerCase();

  // Tekster fra translations via data-attributter (med fallback)
  const sendTodayText = root.dataset.sendToday || "i dag";
  const sendTomorrowText = root.dataset.sendTomorrow || "i morgen";
  const nextWeekdayText = root.dataset.nextWeekday || "næste hverdag";

  const isWeekday = (d) => {
    const day = d.getDay();
    return day !== 0 && day !== 6;
  };

  function nextWeekdayAtCutoff(from) {
    const d = new Date(from);
    d.setMilliseconds(0);
    d.setSeconds(0);
    d.setMinutes(0);
    d.setHours(cutoffHour);

    if (from.getTime() >= d.getTime()) d.setDate(d.getDate() + 1);
    while (!isWeekday(d)) d.setDate(d.getDate() + 1);

    return d;
  }

  function setMode(mode) {
    elCountdownWrap.hidden = true;
    elInfoWrap.hidden = true;

    if (mode === "countdown") elCountdownWrap.hidden = false;
    if (mode === "info") elInfoWrap.hidden = false;
  }

  function tick() {
    if (!inStock) {
      setMode("info");
      return;
    }

    const now = new Date();
    const h = now.getHours() + now.getMinutes() / 60;
    const weekday = isWeekday(now);

    if (h >= cutoffHour && h < eveningHour) {
      setMode("info");
      return;
    }

    setMode("countdown");

    const target = nextWeekdayAtCutoff(now);
    let diff = Math.max(0, target.getTime() - now.getTime());

    const hours = Math.floor(diff / (1000 * 60 * 60));
    diff -= hours * 1000 * 60 * 60;
    const mins = Math.floor(diff / (1000 * 60));
    diff -= mins * 1000 * 60;
    const secs = Math.floor(diff / 1000);

    elTime.textContent = `${hours}t ${String(mins).padStart(2, "0")}m ${String(secs).padStart(2, "0")}s`;

    let whenText = sendTodayText;

    if (!weekday) {
      whenText = nextWeekdayText;
    } else if (h >= eveningHour) {
      whenText = after20Wording === "today" ? sendTodayText : sendTomorrowText;
    }

    elWhen.textContent = whenText;
  }

  tick();
  if (inStock) setInterval(tick, 1000);
})();
